<template>
  <div class="row q-gutter-sm">
    <q-chip
      v-for="modifier in (props.value.data || props.value)"
      :key="modifier.id"
      :class="{ 'bg-primary text-white': props.row.isDefaultModifier && props.row.isDefaultModifier(modifier) }"
      :label="modifier.nameWithPrice"
    />
  </div>
</template>

<script>

export default {
  name: 'ModifiersCell',
  props: {
    props: {
      type: Object,
      required: true
    }
  }
}

</script>
